module.exports = __webpack_public_path__ + "static/media/document.e843f15d.svg";